import { useFormik } from "formik";
import { profileSchema } from "../utils/validations";
import { useGetUserInfoQuery, useUpdateProfileMutation } from "../store";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { showToast, ToastType } from "../utils/toast.utils";
import { useEffect } from "react";

const UserInfoForm = () => {
  const { data: user, isLoading: isUserLoading } = useGetUserInfoQuery();
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();

  const {
    handleSubmit,
    handleBlur,
    handleChange,
    values,
    errors,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
    },
    validationSchema: profileSchema,
    onSubmit: async (values) => {
      const result = await updateProfile(values);
      if (!result.error) {
        showToast("Informations personnelles modifiées", ToastType.SUCCESS);
      }
    },
  });

  useEffect(() => {
    if (user) {
      setValues({
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
      });
    }
  }, [user, setValues]);

  if (isUserLoading) return <div>Chargement...</div>;

  return (
    <div className="bg-white p-6 rounded shadow-lg border border-gray-100">
      <h2 className="text-xl font-semibold mb-4 text-primary">
        Informations Personnelles
      </h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <TextField
          id="firstName"
          placeholder="Prénom"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <TextField
          id="lastName"
          placeholder="Nom"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <TextField
          id="phone"
          placeholder="Téléphone"
          value={values.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <Button
          type="submit"
          disabled={isLoading}
          className="mt-2 bg-primary text-white py-2 rounded font-bold justify-center"
        >
          Mettre à jour
        </Button>
      </form>
    </div>
  );
};

export default UserInfoForm;
